import './RequiredFields.css';
import { track } from '../analytics';
import hebrewLabel from '../hebrewLabels';
import React, { useState, useContext } from 'react';
import { UserContext } from './UserContext';
import {createPortal} from 'react-dom';
import axios from 'axios';
import './SignUpPrestige.css';
import SocialAuth from './SocialAuth';
import FloatingError from './FloatingError';
import API_BASE_URL from '../config';
import CityPicker from './CityPicker';
import TermsModal from './TermsModal';
const GENDERS = ['male', 'female', 'other'];
const INTEREST_CATEGORIES = [
  { label: "🎮 גיימינג וטכנולוגיה", items: ["גיימינג", "משחקי מחשב", "משחקי קונסולה", "משחקים בנייד", "מציאות מדומה ורבודה", "תכנות", "בינה מלאכותית וטכנולוגיה", "גאדג׳טים", "אבטחת סייבר", "קריפטו ו־Web3"] },
  { label: "🎬 בידור", items: ["סרטים", "סדרות", "אנימה", "סרטים תיעודיים", "סטנדאפ", "פודקאסטים", 'YouTube', "סטרימינג", "תיאטרון", "משחקי קופסה"] },
  { label: "🎵 מוזיקה", items: ["פופ", "רוק", 'היפ־הופ', "מוזיקה אלקטרונית", "ג׳אז", "מוזיקה קלאסית", 'R&B', "מטאל", "אינדי", "נגינה"] },
  { label: "🏃 ספורט וכושר", items: ["חדר כושר והרמת משקולות", "ריצה", "רכיבה על אופניים", "שחייה", "כדורגל", "כדורסל", "טניס", "אומנויות לחימה", "יוגה", "טיולים בטבע"] },
  { label: "🌿 טבע ושטח", items: ["טיולים בטבע", "קמפינג", "טיפוס", "גלישה", "סקי וסנובורד", "דיג", "גינון", "צפרות", "אסטרונומיה", "תרמילאות"] },
  { label: "🍕 אוכל ושתייה", items: ["בישול", "אפייה", "קפה", "יין", "בירות בוטיק", "סושי", "תזונה מהצומח", "אוכל רחוב", "מסעדות שף", "הכנת ארוחות מראש"] },
  { label: "✈️ טיולים ותרבות", items: ["מסעות", "תרמילאות", "טיולי דרכים", "שפות", "היסטוריה", "מוזיאונים", "צילום", "אדריכלות", "התנדבות", "פסטיבלים"] },
  { label: "📚 למידה ויצירה", items: ["קריאה", "כתיבה", "ציור ואיור", "ציור בצבע", "פיסול", "צילום", "יצירת סרטים", "עיצוב", "אופנה", "עשה זאת בעצמך ומלאכת יד"] },
  { label: "🧘 רווחה ואורח חיים", items: ["מדיטציה", "קשיבות", "כתיבת יומן", "אסטרולוגיה", "רוחניות", 'התפתחות אישית', "מינימליזם", "קיימות", "בריאות הנפש", "תזונה"] },
  { label: "🐾 חיות ומחמד", items: ["כלבים", "חתולים", "סוסים", "זוחלים", "ציפורים", "חיים בים", "חיות בר", "הצלת בעלי חיים", "טבעונות", "גן חיות ואקווריום"] },
];

function SignUp({ initiallyOpen = false, onClose } = {}) {
  const { setToken, setCurrentUser } = useContext(UserContext);
  const completeRegistration = data => {
    if (!data?.access_token || !data?.user) throw new Error('Missing verified session');
    localStorage.setItem('token', data.access_token);
    localStorage.setItem('currentUser', JSON.stringify(data.user));
    setToken(data.access_token);
    setCurrentUser(data.user);
    setVerificationStep('');
    setShowSignUpForm(false);
    onClose?.();
  };
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    email: '',
    age: '',
    gender: '',
    bio: '',
    interests: [],
    preferredAgeRange: { min: 18, max: 60 },
    preferredGender: '',
    city: '',
    phoneNumber: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const fieldMessage = name => {
    const value = String(formData[name] ?? '').trim();
    if (!value) return name === 'phoneNumber' ? '' : 'יש למלא שדה חובה זה';
    if (name === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) return 'יש להזין כתובת דוא״ל תקינה';
    if (name === 'phoneNumber' && !/^\+?[0-9\s()-]{7,20}$/.test(value)) return 'יש להזין מספר טלפון תקין';
    if (name === 'age' && (!Number.isInteger(Number(value)) || Number(value) < 18 || Number(value) > 120)) return 'יש להזין גיל שלם בין 18 ל־120';
    return '';
  };
  const fieldProps = name => ({'aria-required': name !== 'phoneNumber', 'aria-invalid': submitted && !!fieldMessage(name), 'aria-describedby': submitted && fieldMessage(name) ? `required-${name}` : undefined});
  const fieldError = name => submitted && fieldMessage(name) ? <span className="required-field-error" id={`required-${name}`}>{fieldMessage(name)}</span> : null;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [showSignUpForm, setShowSignUpForm] = useState(initiallyOpen);
  const [showVerifyNotice, setShowVerifyNotice] = useState(false);
  const [resendMessage, setResendMessage] = useState('');
  const [verificationStep, setVerificationStep] = useState(''); // '' | 'show' | 'sent' | 'verified'
  const [verifyCode, setVerifyCode] = useState('');
  const [verificationEmail, setVerificationEmail] = useState('');
  const [registeredUserId, setRegisteredUserId] = useState(null);
  const [showTerms, setShowTerms] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'file') {
      setFormData(previous => ({ ...previous, [name]: files[0] }));
    } else if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        interests: checked
          ? [...prevState.interests, value]
          : prevState.interests.filter(interest => interest !== value)
      }));
    } else {
        setFormData(previous => ({ ...previous, [name]: value }));
      }
    };

  const handleRangeChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      preferredAgeRange: {
        ...prevState.preferredAgeRange,
        [name]: parseInt(value, 10)
      }
    }));
  };

  const isFormValid = () => ['username','password','email','phoneNumber','profileImage','age','gender','city','preferredGender'].every(name => !fieldMessage(name));

  const register = async () => {
    setSubmitted(true);
    if (!isFormValid()) {
      setErrorMessage("יש למלא את כל שדות החובה.");
      return;
    }

    track('registration_started');
    const formDataToSend = new FormData();
    for (const key in formData) {
      if (key === 'profileImage' && formData[key]) {
        formDataToSend.append('file', formData[key]);
      } else if (key === 'preferredAgeRange') {
        formDataToSend.append('preferredAgeRange[min]', formData[key].min);
        formDataToSend.append('preferredAgeRange[max]', formData[key].max);
      } else if (key === 'interests') {
        // Convert array to JSON string for the backend
        formDataToSend.append('interests', JSON.stringify(formData[key]));
      } else {
        formDataToSend.append(key, formData[key]);
      }
    }

    try {
      setLoading(true);
      setErrorMessage('');
      setSuccessMessage('');
      setShowVerifyNotice(false);
      setResendMessage('');

      const response = await axios.post(`${API_BASE_URL}/register`, formDataToSend);
      track('registration_completed');
      setSuccessMessage(response.data.message);

      // If the user registered with email, show the verification code step
      if (response.data.needs_verification) {
        setVerificationEmail(formData.email);
        setRegisteredUserId(response.data.user_id);
        setVerificationStep('sent');

        // If a dev_code was returned (no SMTP configured), auto-fill it
        if (response.data.dev_code) {
          setVerifyCode(response.data.dev_code);
          // Auto-verify immediately
          try {
            const verifyRes = await axios.post(`${API_BASE_URL}/verify_email`, {
              email: formData.email,
              code: response.data.dev_code,
            });
            if (verifyRes.data.access_token) {
              completeRegistration(verifyRes.data);
            }
          } catch (e) {
            console.error('Auto-verify failed:', e);
          }
        }
      } else {
        setTimeout(() => {
          setShowSignUpForm(false);
        }, 1500);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setErrorMessage(error.response.data.message);
      } else if (error.code === 'auth/email-already-in-use') {
        setErrorMessage("כבר קיים חשבון עם כתובת הדוא״ל הזאת. היכנסו לחשבון.");
      } else if (error.code === 'auth/weak-password') {
        setErrorMessage("הסיסמה חלשה מדי. השתמשו ב־6 תווים לפחות.");
      } else if (error.code === 'auth/invalid-email') {
        setErrorMessage("יש להזין כתובת דוא״ל תקינה.");
      } else {
        console.error('Error during registration:', error);
        setErrorMessage("אירעה שגיאה במהלך ההרשמה.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleResendVerification = async () => {
    setResendMessage('');
    try {
      const { getAuth, firebaseConfigured } = await import('../firebase');
      const { sendEmailVerification } = await import('firebase/auth');
      if (!firebaseConfigured) {
        setResendMessage("היכנסו לחשבון כדי לשלוח שוב את הודעת האימות.");
        return;
      }
      const auth = await getAuth();
      if (!auth || !auth.currentUser) {
        setResendMessage("היכנסו לחשבון כדי לשלוח שוב את הודעת האימות.");
        return;
      }
      await sendEmailVerification(auth.currentUser);
      setResendMessage("הודעת האימות נשלחה. בדקו את תיבת הדואר.");
    } catch (err) {
      console.error('Resend verification error:', err);
      setResendMessage("לא ניתן לשלוח שוב את ההודעה. נסו שוב.");
    }
  };

  const handleShowSignUpForm = () => {
    setShowSignUpForm(true);
  };
  const handleCloseSignUpForm = () => {
    setShowSignUpForm(false);
  };

  return (
    <div className="signup-container">
      {!showSignUpForm && (
        <button onClick={handleShowSignUpForm}>הרשמה</button>
      )}

      {showSignUpForm && createPortal((
        <div className="overlay signup-overlay">
          <div className='signup-page signup-prestige'>
            <button aria-label="סגירת חלון ההרשמה" onClick={() => { handleCloseSignUpForm(); onClose?.(); }} className="close-button">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>
            </button>
            <header className="signup-intro"><span className="signup-eyebrow">CONNEXT · ספיד דייטינג</span><h2>כמה דקות.<br/><em>המון אפשרויות.</em></h2><p>קודם שומעים. אחר כך רואים.<br/>נרשמים ומתחילים להכיר, שיחה אחת בכל פעם.</p><div className="signup-intro-line" aria-hidden="true">✦</div></header>

            {/* Social sign-up (Google / Apple) */}
            <SocialAuth onSignIn={() => {}} dividerText="או נרשמים עם" />

            {/* Email verification notice (email sign-up) */}
            {showVerifyNotice && (
              <div className="verify-notice">
                <p>✅ קישור אימות נשלח אל <strong>{formData.email}</strong>.</p>
                <p>לחצו על הקישור כדי לאמת את הדוא״ל ואז היכנסו לחשבון.</p>
                <button type="button" className="link-button" onClick={handleResendVerification}>
                  שליחת הודעת האימות מחדש
                </button>
                {resendMessage && <p className="success-message">{resendMessage}</p>}
              </div>
            )}

            {/* Username */}
            <div className="signup-section-heading"><span>01</span><div><h3>נעים להכיר</h3><p>מתחילים בפרטים הבסיסיים.</p></div></div>
            <div className="signup-details-grid">
            <div className='user-box' data-field-error={submitted && !!fieldMessage('username')}>
              <input {...fieldProps('username')}
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="שם משתמש"
              />
              <label>שם משתמש</label>
            {fieldError('username')}</div>

            {/* Password */}
            <div className='user-box' data-field-error={submitted && !!fieldMessage('password')}>
              <input {...fieldProps('password')}
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="סיסמה"
              />
              <label>סיסמה</label>
            {fieldError('password')}</div>

            {/* Email (used for account verification when provided) */}
            <div className='user-box' data-field-error={submitted && !!fieldMessage('email')}>
              <input {...fieldProps('email')} required aria-label="דוא״ל"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="דוא״ל (חובה)"
              />
              <label>דוא״ל <span aria-hidden="true">*</span></label>
            {fieldError('email')}</div>

            {/* Gender */}
            <div className='user-box' data-field-error={submitted && !!fieldMessage('gender')}>
              <select {...fieldProps('gender')} aria-label="מגדר" name="gender" onChange={handleChange} value={formData.gender}>
                <option value="">מגדר</option>
                {GENDERS.map(gender => (
                  <option key={gender} value={gender}>{hebrewLabel(gender)}</option>
                ))}
              </select>
              <label>מגדר</label>
            {fieldError('gender')}</div>

            {/* Age */}
            <div className='user-box' data-field-error={submitted && !!fieldMessage('age')}>
              <input {...fieldProps('age')}
                type="number"
                name="age"
                value={formData.age}
                onChange={handleChange}
                placeholder="גיל"
                min="18"
                max="120"
              />
              <label>גיל</label>
            {fieldError('age')}</div>

            {/* City */}
            <div className='user-box' data-field-error={submitted && !!fieldMessage('city')}>
              <CityPicker {...fieldProps('city')} value={formData.city} onChange={handleChange} allowLocation />
              <label>יישוב</label>
            {fieldError('city')}</div>

            {/* Phone Number */}
            <div className='user-box' data-field-error={submitted && !!fieldMessage('phoneNumber')}>
              <input {...fieldProps('phoneNumber')} aria-label="מספר טלפון"
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder="מספר טלפון"
              />
              <label>מספר טלפון (לא חובה)</label>
            {fieldError('phoneNumber')}</div>

            {/* Preferred Gender */}
            </div>
            <div className="signup-section-heading"><span>02</span><div><h3>החיבור שמתאים לכם</h3><p>האנשים והדברים הקטנים שמושכים אתכם.</p></div></div>
            <div className='user-box' data-field-error={submitted && !!fieldMessage('preferredGender')}>
            <select {...fieldProps('preferredGender')} aria-label="אשמח להכיר" name="preferredGender" onChange={handleChange} value={formData.preferredGender}>
                <option value="">אשמח להכיר…</option>
                {GENDERS.map(gender => (
                <option key={gender} value={gender}>{hebrewLabel(gender)}</option>
                ))}
            </select>
            <label>אשמח להכיר…</label>
            {fieldError('preferredGender')}</div><br />

            {/* Interests */}
            <div className='user-box' style={{ marginTop: '15px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                תחומי עניין ({formData.interests.length} נבחרו)
              </label>
              <div className="profile-interests-categories" style={{ maxHeight: '300px', overflowY: 'auto', padding: '8px', border: '1px solid rgba(0,212,255,0.2)', borderRadius: '8px', background: 'rgba(5,5,20,0.4)' }}>
                {INTEREST_CATEGORIES.map(cat => (
                  <div key={cat.label} style={{ marginBottom: '8px' }}>
                    <p style={{ color: 'rgba(0,212,255,0.8)', fontSize: '12px', margin: '4px 0', fontWeight: 'bold' }}>{cat.label}</p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                      {cat.items.map(interest => (
                        <label
                          key={interest}
                          className="interest-chip"
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '3px',
                            padding: '3px 8px',
                            borderRadius: '14px',
                            fontSize: '11px',
                            cursor: 'pointer',
                            background: formData.interests.includes(interest) ? 'rgba(0,212,255,0.25)' : 'rgba(255,255,255,0.06)',
                            border: formData.interests.includes(interest) ? '1px solid rgba(0,212,255,0.6)' : '1px solid rgba(255,255,255,0.1)',
                            color: formData.interests.includes(interest) ? '#fff' : 'rgba(255,255,255,0.6)',
                            opacity: formData.interests.includes(interest) ? 1 : 0.7,
                          }}
                        >
                          <input
                            type="checkbox"
                            name="interests"
                            value={interest}
                            checked={formData.interests.includes(interest)}
                            onChange={handleChange}
                            style={{ display: 'none' }}
                          />
                          {interest}
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div><br />

            {/* Preferred Age Range */}
            <div className='user-box'>
              <label>טווח גילאים</label><br />
              <input
                type="range"
                name="min"
                min="18"
                max="100"
                value={formData.preferredAgeRange.min}
                onChange={handleRangeChange}
              />
              <input
                type="range"
                name="max"
                min="18"
                max="100"
                value={formData.preferredAgeRange.max}
                onChange={handleRangeChange}
              />
              <div>מגיל: {formData.preferredAgeRange.min} — עד גיל: {formData.preferredAgeRange.max}</div>
            </div>

            {/* Bio */}
            <div className="signup-section-heading"><span>03</span><div><h3>עוד קצת עליכם</h3><p>הוסיפו את הפרטים שנותנים לשיחה אופי משלכם.</p></div></div>
            <div className='user-box'>
              <textarea
                name="bio"
                value={formData.bio}
                onChange={handleChange}
                placeholder="קצת עליי"
              />
              <label>קצת עליי</label>
            </div>

            <div className='user-box' data-field-error={submitted && !!fieldMessage('profileImage')}>
            <input {...fieldProps('profileImage')} required aria-label="תמונת פרופיל"
                type="file"
                name="profileImage"
                onChange={handleChange}
            />
            <label>תמונת פרופיל <span aria-hidden="true">*</span></label>
            {fieldError('profileImage')}</div>

            {/* Error and Success Messages */}
            <FloatingError message={errorMessage} onDismiss={() => setErrorMessage('')} />
            {successMessage && <div className="success-message">{successMessage}</div>}

            {/* Register Button — first shows Terms of Use */}
            <button className='btn-2' onClick={() => { setSubmitted(true); if (isFormValid()) setShowTerms(true); else setErrorMessage("יש למלא את כל שדות החובה."); }} disabled={loading}>{loading ? "יוצרים את החשבון שלכם…" : "יצירת החשבון שלי"}
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </button>
            {formData.email && (
              <p className="form-hint">💡 הוספת דוא״ל מאפשרת לנו לאמת את החשבון שלכם.</p>
            )}
          </div>
        </div>
      ),document.body)}

      {/* Verification code screen — shown after registration with email */}
      {verificationStep === 'sent' && (
        <div className="signin-page">
          <h2 style={{ marginBottom: '15px' }}>📧 אימות כתובת הדוא״ל</h2>
          <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: '20px', fontSize: '14px' }}>
            קוד אימות בן 5 ספרות נשלח אל <strong>{verificationEmail}</strong>
          </p>
          <div className='user-box'>
            <input
              type="text"
              value={verifyCode}
              onChange={(e) => setVerifyCode(e.target.value.replace(/\D/g, '').slice(0, 5))}
              placeholder="הזינו קוד בן 5 ספרות"
              maxLength={5}
              style={{ textAlign: 'center', fontSize: '24px', letterSpacing: '8px' }}
            />
            <label>קוד אימות</label>
          </div>
          <FloatingError message={errorMessage} onDismiss={() => setErrorMessage('')} />
          {resendMessage && <div className="success-message">{resendMessage}</div>}
          <div className='signin-container-button'>
            <button
              className='btn-1'
              onClick={async () => {
                if (!verifyCode || verifyCode.length !== 5) {
                  setErrorMessage("יש להזין את הקוד בן 5 הספרות");
                  return;
                }
                setErrorMessage('');
                setLoading(true);
                try {
                  const verifyRes = await axios.post(`${API_BASE_URL}/verify_email`, {
                    email: verificationEmail,
                    code: verifyCode,
                  });
                  if (verifyRes.data.access_token) {
                    completeRegistration(verifyRes.data);
                  }
                } catch (err) {
                  setErrorMessage(err.response?.data?.message || "האימות נכשל");
                } finally {
                  setLoading(false);
                }
              }}
              disabled={loading}
            >
              {loading ? 'מאמתים…' : "אימות דוא״ל"}
            </button>
          </div>
          <button
            type="button"
            className="link-button"
            style={{ marginTop: '12px', fontSize: '13px' }}
            onClick={async () => {
              setResendMessage('');
              setErrorMessage('');
              try {
                const res = await axios.post(`${API_BASE_URL}/send_verification_code`, {
                  email: verificationEmail,
                  user_id: registeredUserId,
                });
                if (res.data.dev_code) {
                  setVerifyCode(res.data.dev_code);
                  // Auto-verify
                  const verifyRes = await axios.post(`${API_BASE_URL}/verify_email`, {
                    email: verificationEmail,
                    code: res.data.dev_code,
                  });
                  if (verifyRes.data.access_token) {
                    completeRegistration(verifyRes.data);
                  }
                } else {
                  setResendMessage("הקוד נשלח שוב! בדקו את הדוא״ל.");
                }
              } catch (err) {
                setResendMessage("לא ניתן לשלוח שוב. נסו שוב.");
              }
            }}
          >
            שליחת הקוד מחדש
          </button>
        </div>
      )}

      {/* Verified success */}
      {verificationStep === 'verified' && (
        <div className="signin-page">
          <h2 style={{ marginBottom: '15px' }}>✅ הדוא״ל אומת!</h2>
          <p style={{ color: 'rgba(255,255,255,0.6)' }}>נכנסתם לחשבון. מיד ממשיכים…</p>
        </div>
      )}

      {/* Terms of Use modal — shown when registering */}
      {showTerms && (
        <TermsModal
          onAccept={() => { setShowTerms(false); register(); }}
          onDecline={() => { setShowTerms(false); setErrorMessage("יש להסכים לתנאי השימוש כדי ליצור חשבון."); }}
        />
      )}
    </div>
  );

}

export default SignUp;
